export default __webpack_public_path__ + "static/media/mw11.8c668ad5.webp";